import { Controller } from '@hotwired/stimulus'

// { "RepCode": ["AccountNumber", ...], ... }
type AccountsByManager = Record<string, string[]>

export default class SubmissionAccountSearchController extends Controller<HTMLElement> {
  declare accountsByManagerValue: AccountsByManager
  declare readonly repCodeInputTarget: HTMLInputElement

  static targets = ['repCodeInput']

  static values = {
    accountsByManager: { default: {}, type: Object },
  }

  updateRepCode(event: Event) {
    const accountNumber = (event.target as HTMLSelectElement).value
    const repCode = Object.keys(this.accountsByManagerValue).find(repCode =>
      this.accountsByManagerValue[repCode].includes(accountNumber),
    )

    this.repCodeInputTarget.value = repCode || ''
  }
}
